import type * as ProfilePageModule from "../../components/Profile";
import type * as SettingsPageModule from "../(primary)/settings/page";
import type * as LoginPageModule from "../../containers/login-page";

export const loadProfilePage = async (): Promise<typeof ProfilePageModule> =>
  await import("../../components/Profile");
export const loadSettingsPage = async (): Promise<typeof SettingsPageModule> =>
  await import("../(primary)/settings/page");
export const loadLoginPage = async (): Promise<typeof LoginPageModule> =>
  await import("../../containers/login-page");
